/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type WhatsAppWebhookSetupRequest = {
  appId: string;
};

/** @internal */
export const WhatsAppWebhookSetupRequest$inboundSchema: z.ZodType<
  WhatsAppWebhookSetupRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  app_id: z.string(),
}).transform((v) => {
  return remap$(v, {
    "app_id": "appId",
  });
});
/** @internal */
export type WhatsAppWebhookSetupRequest$Outbound = {
  app_id: string;
};

/** @internal */
export const WhatsAppWebhookSetupRequest$outboundSchema: z.ZodType<
  WhatsAppWebhookSetupRequest$Outbound,
  z.ZodTypeDef,
  WhatsAppWebhookSetupRequest
> = z.object({
  appId: z.string(),
}).transform((v) => {
  return remap$(v, {
    appId: "app_id",
  });
});

export function whatsAppWebhookSetupRequestToJSON(
  whatsAppWebhookSetupRequest: WhatsAppWebhookSetupRequest,
): string {
  return JSON.stringify(
    WhatsAppWebhookSetupRequest$outboundSchema.parse(
      whatsAppWebhookSetupRequest,
    ),
  );
}
export function whatsAppWebhookSetupRequestFromJSON(
  jsonString: string,
): SafeParseResult<WhatsAppWebhookSetupRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => WhatsAppWebhookSetupRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'WhatsAppWebhookSetupRequest' from JSON`,
  );
}
